export enum AnnouncementTypeEnum {
  "General" = 1,
  "Maintenance" = 2,
  "Feature_Update" = 3,
  "Alert" = 4,
}

export enum AnnouncementPriorityEnum {
  "Low" = 1,
  "Medium" = 2,
  "High" = 3,
}

export enum AnnouncementVisibilityEnum {
  "All_Users" = 1,
  "Clients" = 2,
  "Professionals" = 3,
}

export interface Announcement {
  id: string;
  title: string;
  content: string;
  type: {
    id: number;
  };
  priority: {
    id: number;
  };
  visibility: {
    id: number;
  };
  region: {
    id: string;
  };
  country: {
    id: string;
    name: string;
    code: string;
  };
  publishDate: string;
  expiryDate: string;
  isMobile: boolean;
  isEmail: boolean;
  isWeb: boolean;
  isText?: boolean;
  createdAt?: string;
  updatedAt?: string;
  stats?: {
    views: number;
    acknowledged: number;
  };
}

export interface CreateAnnouncementData {
  title: string;
  content: string;
  type: {
    id: number;
  };
  priority: {
    id: number;
  };
  visibility: {
    id: number;
  };
  region: {
    id: string;
  };
  country: {
    id: string;
    name: string;
    code: string;
  };
  publishDate: string;
  expiryDate: string;
  isMobile: boolean;
  isEmail: boolean;
  isWeb: boolean;
  isText?: boolean;
}

export type UpdateAnnouncementData = CreateAnnouncementData;

export interface AnnouncementFilters {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  type?: string;
  priority?: string;
  visibility?: string;
  status?: string;
  isShowLoader?: boolean;
}

export interface AnnouncementResponse {
  data: Announcement[];
  totalCount: number;
  hasNextPage: boolean;
  currentPage: number;
  currentLimit: number;
}
